"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeHxFetchPhotoArgs = void 0;
function serializeHxFetchPhotoArgs(_arg) {
    var output = [];
    output.push(_arg.emailAddress);
    output.push(_arg.width !== undefined);
    if (_arg.width !== undefined) {
        output.push(_arg.width);
    }
    output.push(_arg.height !== undefined);
    if (_arg.height !== undefined) {
        output.push(_arg.height);
    }
    output.push(_arg.refetchFromServer !== undefined);
    if (_arg.refetchFromServer !== undefined) {
        output.push(_arg.refetchFromServer);
    }
    output.push(_arg.manualSyncModeBehavior);
    return output;
}
exports.serializeHxFetchPhotoArgs = serializeHxFetchPhotoArgs;
